function tableArrows(tableResponsiveSelector = '.table-responsive'){
    document.querySelectorAll(tableResponsiveSelector).forEach(tableResponsive => {
        const tableOverflow = tableResponsive.querySelector('.overflow');
        const table = tableOverflow.querySelector('table');
        let tableResponsiveArrowRightFlag = false;

        tableResponsive.insertAdjacentHTML('afterbegin', `
            <button class="table-responsive__arrow table-responsive__arrow_left" aria-label="Прокрутить влево">
                <svg><use xlink:href="img/sprite.svg#arrow-left"></use></svg>
            </button>
            <button class="table-responsive__arrow table-responsive__arrow_right" aria-label="Прокрутить вправо">
                <svg><use xlink:href="img/sprite.svg#arrow-left"></use></svg>
            </button>
        `);

        // если таблица не помещается в контентную область, то активировать флаг
        if (table.offsetWidth > tableOverflow.offsetWidth) {
            tableResponsiveArrowRightFlag = true;
        }

        window.addEventListener('resize', () => {
            if (table.offsetWidth > tableOverflow.offsetWidth) {
                tableResponsiveArrowRightFlag = true;
            }
        });

        // если таблица не помещается в контентную область, показывать стрелку справа
        if (tableResponsiveArrowRightFlag) {
            tableResponsive.classList.add('table-responsive__arrow_right-on');
        }

        tableOverflow.addEventListener('scroll', () => {
            // показать стрелку слева
            if (tableOverflow.scrollLeft > 0) {
                tableResponsive.classList.add('table-responsive__arrow_left-on');
            } else {
                tableResponsive.classList.remove('table-responsive__arrow_left-on');
            }

            // показать стрелку справа
            if (tableResponsiveArrowRightFlag && (tableOverflow.scrollLeft + tableResponsive.offsetWidth) < table.offsetWidth) {
                tableResponsive.classList.add('table-responsive__arrow_right-on');
            } else {
                tableResponsive.classList.remove('table-responsive__arrow_right-on');
            }
        });

        let leftPos = tableOverflow.scrollLeft;

        //клик на кнопки влево и вправо - гориз.скролл
        tableResponsive.querySelector('.table-responsive__arrow_left').addEventListener('click', () => {
            leftPos = tableOverflow.scrollLeft;
            tableOverflow.scrollTo({ left: leftPos - 100, behavior: 'smooth' });
        });

        tableResponsive.querySelector('.table-responsive__arrow_right').addEventListener('click', () => {
            leftPos = tableOverflow.scrollLeft;
            tableOverflow.scrollTo({ left: leftPos + 100, behavior: 'smooth' });
        });
    });
}
export default tableArrows;